import { render, staticRenderFns } from "./CalendarEventsDay.vue?vue&type=template&id=10ce84db&scoped=true"
import script from "./CalendarEventsDay.vue?vue&type=script&lang=js"
export * from "./CalendarEventsDay.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventsDay.vue?vue&type=style&index=0&id=10ce84db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce84db",
  null
  
)

export default component.exports